/* eslint react/no-did-mount-set-state: 0 */
/* eslint react/prop-types: 0 */
/* eslint consistent-return: 0 */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalCuandoUtilizarEconsulta.css';
import ImageCheck from '../../../../public/images/Tabla green.png';
import ImageCruz from '../../../../public/images/Tabla red.png';

class ModalCuandoUtilizarEconsulta extends React.Component {
  render() {
    return (
      <div
        className={`${s.modalScroll} modal fade`}
        id="ModalCuandoUtilizarEconsulta"
      >
        <div className="modal-dialog  modal-lg">
          <div className={`${s.modalContent} modal-content`}>
            <div className={`${s.modalHeader} modal-header`}>
              <h5 className={`${s.modalTitle} modal-title`}>
                Cuándo Utilizar E-Consulta
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              className="modal-body"
              style={{
                maxHeight: 'calc(100vh - 212px)',
                overflowY: 'auto',
                paddingBottom: '0',
              }}
            >
              <div className="row">
                <div className={`${s.noPadding} col-sm-6`}>
                  <table className={`${s.table} table table-striped`}>
                    <thead>
                      <tr style={{ borderRight: '1px solid #fff' }}>
                        <th scope="col" style={{ textAlign: 'center' }}>
                          <img alt="Anterior" src={ImageCheck} />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Tos / Catarro / Fiebre / Congestión nasal</td>
                      </tr>
                      <tr>
                        <td>Diarrea / Cólico abdominal</td>
                      </tr>
                      <tr>
                        <td>Náuseas y vómitos</td>
                      </tr>
                      <tr>
                        <td>Dolor al orinar</td>
                      </tr>
                      <tr>
                        <td>Picaduras</td>
                      </tr>
                      <tr>
                        <td>Erupciones en la piel</td>
                      </tr>
                      <tr>
                        <td>Dolor articular o muscular</td>
                      </tr>
                      <tr>
                        <td>Dolor de cabeza</td>
                      </tr>
                      <tr>
                        <td>Segunda opinión sobre temas médicos</td>
                      </tr>
                      <tr>
                        <td>Medicina del viajero</td>
                      </tr>
                      <tr>
                        <td>Recomendaciones de vacunación</td>
                      </tr>
                      <tr>
                        <td>Cálculo de dosis de un medicamento recetado</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className={`${s.noPadding} col-sm-6`}>
                  <table className={`${s.table} table table-striped`}>
                    <thead>
                      <tr>
                        <th scope="col" style={{ textAlign: 'center' }}>
                          <img alt="Anterior" src={ImageCruz} />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Dolor de pecho</td>
                      </tr>
                      <tr>
                        <td>Falta de aire</td>
                      </tr>
                      <tr>
                        <td>Hemorragias</td>
                      </tr>
                      <tr>
                        <td>Fiebre por más de 48 horas</td>
                      </tr>
                      <tr>
                        <td>Fiebre en menores de 3 meses</td>
                      </tr>
                      <tr>
                        <td>Pérdida de la conciencia</td>
                      </tr>
                      <tr>
                        <td>Desorientación</td>
                      </tr>
                      <tr>
                        <td>Quemaduras</td>
                      </tr>
                      <tr>
                        <td>Fracturas</td>
                      </tr>
                      <tr>
                        <td>Pacientes con inmunosupresión</td>
                      </tr>
                      <tr>
                        <td>Pacientes con problemas oncológicos</td>
                      </tr>
                      <tr>
                        <td>Cualquier situación de riesgo de vida</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className={`${s.modalFooter} modal-footer`}>
              <button
                data-dismiss="modal"
                className="btn btn-danger"
                onClick={this.print}
                style={{ backgroundColor: '#E4002B', cursor: 'pointer' }}
              >
                Lo entiendo
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* const mapStateToProps = state => ({
  removeTurnoResp: state.turno.remove,
}); */

export default connect(null, null)(withStyles(s)(ModalCuandoUtilizarEconsulta));



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalCuandoUtilizarEconsulta/ModalCuandoUtilizarEconsulta.js